














import { Component, Vue } from 'vue-property-decorator';

import flagKeys from '@/constants/flagKeys';

import Typography from '@/components/atoms/Typography/Typography.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';

import RefundPolicyPageV1 from './v1/RefundPolicy.vue';
import RefundPolicyPageV2 from './v2/RefundPolicy.vue';

import { needLaunchRewardsProgram } from '@/utils/start-guide';

@Component({
  components: {
    Page,
    RefundPolicyPageV1,
    RefundPolicyPageV2,
    Typography
  }
})
export default class RefundPolicy extends Vue {
  get newRefundPolicyPageIsActive() {
    const flags = this.$store.getters['flags/getFlags'] || [];

    return flags.includes(flagKeys.newRefundPage);
  }

  get tPrefix() {
    return 'coinLoyaltySettings.refundPolicy';
  }

  get pageTitle() {
    return this.$t(`${this.tPrefix}.title`);
  }
}
